export class IoNewsMockup {
    static blog1 = {
        'id': '45',
        'name': 'Blog 12 - Radio Show',
        'description': 'Listen to a radio show',
        'publishDate': [
            '2017',
            '10',
            '3'
        ]
    };

    static blog2 = {
        'id': '46',
        'name': 'Blog 13 - Sheets',
        'description': 'Fact Sheets',
        'publishDate': [
            '2017',
            '10',
            '3'
        ]
    };

    static blogsArrayBE = [
        IoNewsMockup.blog1,
        IoNewsMockup.blog2,
        IoNewsMockup.blog1,
        IoNewsMockup.blog2,
        IoNewsMockup.blog1,
        IoNewsMockup.blog2
    ];
}
